'use client'

import type { Data } from '@repo/strapi'
import { MarketoForm } from '@/app/[locale]/blog/_components/MarketoForm'
import AppLink from '@/components/elementary/AppLink'
import { Skeleton } from '@/components/ui/skeleton'
import { MARKETO_FORM_IDS } from '@/lib/constants'
import { ARTICLE_SIDEBAR_TEST_IDS } from '@/lib/test-ids'

export const ArticleSidebarForm = ({
	sidebar,
}: {
	sidebar?: Data.Component<'blog.article-sidebar'> | null
}) => {
	return sidebar?.downloadLink?.href ? (
		<AppLink
			href={sidebar.downloadLink.href}
			variant="primary"
			openExternalInNewTab={sidebar.downloadLink?.newTab ?? false}
			download={sidebar.downloadLink?.download ?? false}
			size="medium"
			className="w-full"
			data-test-id={ARTICLE_SIDEBAR_TEST_IDS.DOWNLOAD_LINK}
		>
			{sidebar.downloadLink?.label}
		</AppLink>
	) : (
		<MarketoForm
			id={sidebar?.marketoFormId ?? MARKETO_FORM_IDS.BLOG_SUBSCRIPTION}
			loadingSkeleton={<BlogSubscriptionSkeleton />}
		/>
	)
}

const BlogSubscriptionSkeleton = () => (
	<div className="flex flex-col gap-3.75">
		<Skeleton className="h-11.25 w-full" />
		<Skeleton className="h-11.25 w-full rounded-full" />
	</div>
)
